import {
  StoreRequisitionFollowUpStateTypes,
  StoreRequisitionFollowUpActionTypes,
} from "./StoreRequisitionFollowUp.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: StoreRequisitionFollowUpStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const StoreRequisitionFollowUpReducer = (
  state: StoreRequisitionFollowUpStateTypes = INITIAL_STATE,
  action: any
): StoreRequisitionFollowUpStateTypes => {
  switch (action.type) {
    case StoreRequisitionFollowUpActionTypes.FETCH_ALL_STORE_REQUISITION_FOLLOW_UP:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case StoreRequisitionFollowUpActionTypes.FETCH_ALL_STORE_REQUISITION_FOLLOW_UP_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case StoreRequisitionFollowUpActionTypes.FETCH_ALL_STORE_REQUISITION_FOLLOW_UP_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case StoreRequisitionFollowUpActionTypes.FETCH_ALL_STORE_REQUISITION_FOLLOW_UP_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case StoreRequisitionFollowUpActionTypes.FETCH_ONE_STORE_REQUISITION_FOLLOW_UP:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case StoreRequisitionFollowUpActionTypes.FETCH_ONE_STORE_REQUISITION_FOLLOW_UP_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case StoreRequisitionFollowUpActionTypes.FETCH_ONE_STORE_REQUISITION_FOLLOW_UP_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case StoreRequisitionFollowUpActionTypes.FETCH_ONE_STORE_REQUISITION_FOLLOW_UP_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default StoreRequisitionFollowUpReducer;
